// File: DifficultyMeter.js
import React from "react";

const DifficultyMeter = ({ level, label }) => {
  return (
    <div className="relative pt-1">
      <div className="flex items-center justify-between">
        <div>
          <span className="text-xs font-medium text-gray-500">Difficulty</span>
        </div>
        <div>
          <span className="text-xs font-semibold text-indigo-700">{label}</span>
        </div>
      </div>
      <div className="overflow-hidden h-1.5 mt-1 text-xs flex rounded bg-gray-200">
        <div
          style={{ width: `${level * 20}%` }}
          className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-indigo-500"
        ></div>
      </div>
    </div>
  );
};

export default DifficultyMeter;
